import React from 'react';
import Modal from 'react-modal';
import Logger from '../../utils/Logger';
import modal from '../../definitions/Modal';
import { FormattedMessage, injectIntl } from 'react-intl';
import OTButton from '../tag/OTButton';
import OTButtonGroup from '../tag/OTButtonGroup';

const { id: module_id } = module;
const logger = Logger(module_id);

const notificationModal = modal({
  content: { width: '400px', padding: '30px 50px' },
});

const BioBankRefusalModal = ({ isOpen, closeModal, intl }) => {
  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={notificationModal}
    >
      <div className="text-center">
        <div className="row-fluid">
          <p style={{ color: '$darkBlueColor', textAlign: 'left' }}>
            <FormattedMessage
              id={`${module_id}.content`}
              values={{
                strong: (chunks) => <strong>{chunks}</strong>,
              }}
            />
          </p>
        </div>
        <div className="row-fluid">
          <OTButtonGroup type={'big'} fullWidth expectedCount={2}>
            <OTButton
              className="ot-button--gray"
              onClick={() => closeModal('cancel')}
            >
              <FormattedMessage id={'back'} />
            </OTButton>
            <OTButton onClick={() => closeModal('next')}>
              <FormattedMessage id={'continue'} />
            </OTButton>
          </OTButtonGroup>
        </div>
      </div>
    </Modal>
  );
};

export default injectIntl(BioBankRefusalModal);
